'use strict';

import { io } from "socket.io-client";

function addEventListeners() {
    $('.dashboard-btn').on('click', exportData);
}

function exportData() {
    let type = $(this).data('export-type');
    let table = document.querySelector('.v-datatable');
    let data = [...table.rows].map(t => [...t.children].map(u => u.innerText))
    let action = `/dashboard/admin/v3/export/${type}`;

    let headers = data[0];
    headers.unshift('')
    headers = headers.map(header => header.replaceAll('filter_list', '').replaceAll('\n', '').trim())
        .filter(header => {
            return header !== '' && header !== 'Output løn';
        });


    let dataWithoutHeaders = data;
    dataWithoutHeaders.splice(0, 1);
    
    dataWithoutHeaders = dataWithoutHeaders.map((item) => {
        return item.filter(subItem => {
            return subItem !== '';
        });
    })

    dataWithoutHeaders = dataWithoutHeaders.filter((item, index) => {
        return !JSON.stringify(item).includes('keyboard_arrow_down');
    })

    $('#export-form').attr('action', action);
    $('#tableData').attr('value', JSON.stringify(dataWithoutHeaders));
    $('#tableHeaders').attr('value', JSON.stringify(headers));

    $('#export-form').submit();
}

addEventListeners();